import React, { useEffect, useState } from 'react';
import request from '../../../../utils/request';
import loaderGif from 'src/pages/common/no_bg_loader.gif';
import moment from 'moment';
import {
  Alert,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Checkbox,
  IconButton,
  Paper,
  Box,
  Grid,
  TablePagination,
  ButtonGroup,
  Button,
  Popper,
  Grow,
  ClickAwayListener,
  MenuList,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Stack
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import EmployeeListItemVertical from './EmployeeListItemVertical';
import EmployeeListItemVerticalEditable from './EmployeeListItemVerticalEditable';
import EmployeeListItemHorizontalEditable from './EmployeeListItemHorizontalEditable';
import EmployeeListItemCreate from './EmployeeListItemCreate';
import { useDispatch, useSelector } from 'react-redux';

import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import {
  selectEndorsmentFormData,
  selectEndorsmentScreenNumber,
  selectPolicyDetails,
  updateEndorsementFormData,
  updateSumInsuredSectionData
} from 'src/features/rfqDataSlice';
import TableSearch from 'src/pages/common/TableSearch';
import UploadSumInsuredGroupWithAction from '../UploadSumInsuredGroupWithAction';
import ExcelSummaryBox from '../ExcelSummaryBox';
import TableSearchWithIcon from 'src/pages/common/TableSearchWithIcon';

function EmployeeListItem({
  sumInsuredData,
  groupDetails,
  policyId,
  productId
}) {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef<HTMLDivElement>(null);
  const [uploadOpen, setUploadOpen] = React.useState(false);
  const [tableListDatas, setTableListDatas] = useState([]);
  const [selectedRows, setSelectedRows] = useState({});
  const dispatch = useDispatch();
  const endorsementFormData = useSelector(selectEndorsmentFormData);
  const policyDetails = useSelector(selectPolicyDetails);
  const sectionId = sumInsuredData?.id;
  const groupId = groupDetails?.id;

  const [totalCount, setTotalCount] = React.useState(0);
  const [offset, setOffset] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [loading, setLoading] = React.useState(false);
  interface SearchState {
    text: string;
    triggerId: number;
  }
  const [searchValue, setSearchValue] = useState<SearchState>({
    text: '',
    triggerId: Date.now(),
  });

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: Event) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }

    setOpen(false);
  };

  useEffect(() => {
    const createRows = tableListDatas.filter(
      (row) => row.actionType === 'create'
    );
    if (createRows.length === 0) return;

    const sectionData = endorsementFormData.sumInsuredSectionData[
      sectionId
    ] || { groups: {} };
    const groupData = sectionData.groups[groupId] || {
      ...groupDetails,
      sumInsuredEntry: []
    };

    let updatedEntries = [...groupData.sumInsuredEntry];

    createRows.forEach((createRow) => {
      const index = updatedEntries.findIndex(
        (entry) => entry.id === createRow.id
      );
      if (index >= 0) {
        updatedEntries[index] = { ...updatedEntries[index], ...createRow };
      } else {
        updatedEntries.push(createRow);
      }
    });

    const updatedGroup = {
      ...groupData,
      sumInsuredEntry: updatedEntries
    };

    const updatedSection = {
      ...sectionData,
      groups: {
        ...sectionData.groups,
        [groupId]: updatedGroup
      },
      sumInsuredHeaderSorted: sumInsuredData?.sumInsuredHeaderSorted
    };

    dispatch(
      updateEndorsementFormData({
        sumInsuredSectionData: {
          ...endorsementFormData.sumInsuredSectionData,
          [sectionId]: updatedSection
        }
      })
    );
  }, [tableListDatas, sectionId, groupId, dispatch, groupDetails]);

  const columns = sumInsuredData?.sumInsuredHeaderSorted || [];
  const endorsementScreenNumber = useSelector(selectEndorsmentScreenNumber);

  useEffect(() => {
    if (policyId)
      getEmployeeListSavedDatas();
  }, [policyId, offset, rowsPerPage, searchValue]);

  const getEmployeeListSavedDatas = async () => {
    setLoading(true);
    request({
      url: 'insurancePolicy/getSumInsuredList',
      method: 'post',
      data: {
        policyId,
        sectionId: sumInsuredData.id,
        listType: 'employeeList',
        orderDirection: 'ASC',
        offset: offset,
        search: searchValue?.text,
        limit: rowsPerPage,
        status: true,
        groupId: groupId
      }
    }).then(
      (response) => {
        setLoading(false);
        const result = response.data.map((item) => ({
          ...item,
          savedStatus: true,
          actionType: null
        }));
        setTotalCount(response['count']);
        setTableListDatas(result);
      },
      (error) => {
        setLoading(false);
        console.log(error);
      }
    );
  };

  const handleChangePage = (event: any, newPage: number): void => {
    setOffset(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+parseInt(event.target.value));
    setOffset(0);
  };

  const handleAddRow = () => {
    const newRow = {
      id: Date.now(),
      familyNo: null,
      serialNo: null,
      name: '',
      employeeNo: null,
      cadre: null,
      dobOfMamber: null,
      gender: '',
      relationshipForTailormade: null,
      sumInsured: '',
      age: null,
      topupSI: null,
      clientDOJ: null,
      dob: null,
      dateOfCoverage: null,
      notInPolicyPeriod: null,
      nationality: '',
      nameOfCountry: null,
      policyId,
      groupId: groupDetails.id,
      policySumInsurredSection: null,
      occupations: '',
      ageRange: '',
      section: null,
      others: null,
      premium: null,
      savedStatus: false,
      actionType: 'create'
    };
    setTableListDatas((prev) => [...prev, newRow]);
  };

  const handleCheckboxChange = (rowData, isChecked, type = 'update') => {
    const sectionId = sumInsuredData.id;
    const groupId = groupDetails.id;

    setSelectedRows((prev) => {
      const currentSection =
        endorsementFormData.sumInsuredSectionData[sectionId] || { groups: {} };

      let currentGroup = currentSection.groups[groupId] || {
        sumInsuredEntry: []
      };

      currentGroup = {
        ...groupDetails,
        ...currentGroup,
      }

      const storeEntries = currentGroup.sumInsuredEntry || [];

      let combinedEntries = storeEntries.filter((r) => r.id !== rowData.id);
      if (isChecked && type != 'delete') {
        rowData = { ...rowData, actionType: 'update' };
        combinedEntries.push(rowData);
      }

      if (type == 'delete') {
        rowData = { ...rowData, actionType: 'delete' };
        combinedEntries.push(rowData);
      }

      const updatedGroup = {
        ...currentGroup, // ✅ keep Excel-related keys and other data
        sumInsuredEntry: combinedEntries
      };

      const updatedSection = {
        ...currentSection,
        groups: {
          ...currentSection.groups,
          [groupId]: updatedGroup
        },
        sumInsuredHeaderSorted: sumInsuredData?.sumInsuredHeaderSorted
      };

      dispatch(
        updateSumInsuredSectionData({
          sumInsuredSectionData: {
            ...endorsementFormData.sumInsuredSectionData,
            [sectionId]: updatedSection
          }
        })
      );

      return {
        ...prev,
        [sectionId]: updatedSection
      };
    });
  };

  const isRowSelected = (rowData) => {
    const section = selectedRows[sumInsuredData.id];
    const group = section?.groups?.[groupDetails.id];
    return group?.sumInsuredEntry?.some((row) => row.id === rowData.id);
  };

  const changeSearch = (searchValue) => {
    setOffset(0);
    setSearchValue(searchValue);
  };

  const exportGroupListTemplate = () => {
    request({
      url: '/rfq/downloadSumInsuredDataTemplate',
      method: 'post',
      data: {
        rfqId: policyDetails?.rfqId,
        sumInsuredSectionid: sumInsuredData.id,
        fileType: 'csv',
        groupId: parseInt(groupDetails.id),
        productId: productId,
        sumInsuredHeaderSorted: sumInsuredData?.sumInsuredHeaderSorted
      }
    })
      .then((response) => {
        if (response.data != 'NA') {
          const link = document.createElement('a');
          link.href = response.data;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      })
      .catch(function (err) {
        console.log(err.message);
      });
  };

  const openGroupDataUploadForm = () => {
    setUploadOpen(true);
  };
  const closeGroupDataUploadForm = () => {
    setUploadOpen(false);
  };


  return (
    <>
      {sumInsuredData?.sumInsuredHeaderSorted.length <= 0 ? (
        <Alert severity="error">
          No headings found against this section...!!
        </Alert>
      ) : (
        <>
          {groupDetails?.name && (
            <Typography
              gutterBottom
              variant="h6"
              component="div"
              className="heading blockHeader"
              style={{ padding: '16px', color: '#fff' }}
            >
              {groupDetails?.name}
            </Typography>
          )}

          <div style={{ overflowX: 'auto' }}>
            {sumInsuredData?.verticalView ? (
              endorsementScreenNumber === 2 ? (
                <EmployeeListItemVerticalEditable
                  sumInsuredData={sumInsuredData}
                  groupDetails={groupDetails}
                  productId={productId}
                />
              ) : (
                <EmployeeListItemVertical
                  sumInsuredData={sumInsuredData}
                  tableListDatas={tableListDatas}
                  groupDetails={groupDetails}
                />
              )
            ) : endorsementScreenNumber === 2 ? (
              <EmployeeListItemHorizontalEditable
                sumInsuredData={sumInsuredData}
                groupDetails={groupDetails}
                productId={productId}
                listItems={tableListDatas}
              />
            ) : (
              <TableContainer sx={{ mt: 1 }} component={Paper}>
                <Table size="small">
                  <TableHead>
                    <TableRow>

                      <TableCell colSpan={columns.length + 3}>
                        <Box display="flex" justifyContent="flex-end" style={{ display: '-webkit-box' }}>
                          <Stack direction="row" spacing={2} sx={{ float: 'right' }}>
                            <ButtonGroup
                              variant="contained"
                              ref={anchorRef}
                              aria-label="split button"

                            >
                              <Button
                                size="small"
                                aria-controls={open ? 'split-button-menu' : undefined}
                                aria-expanded={open ? 'true' : undefined}
                                aria-label="select action"
                                aria-haspopup="menu"
                                onClick={handleToggle}
                              >
                                Actions
                                <ArrowDropDownIcon />
                              </Button>
                            </ButtonGroup>
                            <Popper
                              className="table_action"
                              open={open}
                              anchorEl={anchorRef.current}
                              role={undefined}
                              transition
                              disablePortal
                            >
                              {({ TransitionProps, placement }) => (
                                <Grow
                                  {...TransitionProps}
                                  style={{
                                    transformOrigin:
                                      placement === 'bottom' ? 'center top' : 'center bottom'
                                  }}
                                >
                                  <Paper>
                                    <ClickAwayListener onClickAway={handleClose}>
                                      <MenuList id="split-button-menu" autoFocusItem>
                                        <MenuItem key={'upload'} onClick={openGroupDataUploadForm}>
                                          <ListItemIcon>
                                            <CloudUploadIcon />
                                          </ListItemIcon>
                                          <ListItemText style={{ display: 'flex', justifyContent: 'flex-start' }}>Upload</ListItemText>
                                        </MenuItem>
                                        <MenuItem key={'download'} onClick={exportGroupListTemplate}>
                                          <ListItemIcon>
                                            <CloudDownloadIcon />
                                          </ListItemIcon>
                                          <ListItemText style={{ display: 'flex', justifyContent: 'flex-start' }} >Download Template </ListItemText>
                                        </MenuItem>


                                      </MenuList>
                                    </ClickAwayListener>
                                  </Paper>
                                </Grow>
                              )}
                            </Popper>
                            <TableSearchWithIcon
                              changeSearch={changeSearch}
                              deafultSearchValue={searchValue?.text}
                              width={'400px'}
                            />
                          </Stack>
                        </Box>

                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell padding="checkbox" />
                      <TableCell>SR No</TableCell>
                      {columns.map((col) => (
                        <TableCell key={col.sumInsuredHeader.attribute}>
                          {col.title || col.sumInsuredHeader.title}
                        </TableCell>
                      ))}
                      <TableCell>Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>

                    {loading ? (
                      <TableRow>
                        <TableCell
                          colSpan={columns.length + 3}
                          align="center"
                          sx={{ py: 4 }}
                        >
                          <img
                            src={loaderGif}// your gif path
                            alt="Loading..."
                            style={{ width: 80, height: 80 }}
                          />
                        </TableCell>
                      </TableRow>
                    ) : (tableListDatas
                      // .filter((r) => r.actionType !== 'delete')
                      .map((rowData, index) =>
                        rowData.actionType === 'create' ? (
                          <EmployeeListItemCreate
                            key={rowData.id}
                            rowData={rowData}
                            index={index}
                            columns={columns}
                            productId={productId}
                            onChange={(attr, value) => {
                              const updated = tableListDatas.map(
                                (item, idx) => {
                                  if (idx === index) {
                                    return {
                                      ...item,
                                      [attr]: value
                                    };
                                  }
                                  return item;
                                }
                              );
                              setTableListDatas(updated);
                            }}
                            onDelete={() => {
                              setTableListDatas((prev) =>
                                prev.filter((r) => r.id !== rowData.id)
                              );
                            }}
                          />
                        ) : (
                          <TableRow key={rowData.id}
                            sx={{
                              ...(rowData.actionType === 'delete' && {
                                backgroundColor: '#ffe6e6',
                                '& td': {
                                  color: 'error.main',
                                  textDecoration: 'line-through'
                                }
                              })
                            }}
                          >
                            <TableCell padding="checkbox">
                              <Checkbox
                                checked={isRowSelected(rowData)}
                                onChange={(e) =>
                                  handleCheckboxChange(
                                    rowData,
                                    e.target.checked,
                                    'update'
                                  )
                                }
                              />
                            </TableCell>
                            <TableCell>{index + 1 + offset * rowsPerPage}</TableCell>
                            {columns.map((col) => {
                              const attr = col.sumInsuredHeader.attribute;
                              const val = rowData[attr];
                              const display = val
                                ? [
                                  'dob',
                                  'dateOfCoverage',
                                  'dobOfMamber'
                                ].includes(attr)
                                  ? moment(val).format('DD-MM-YYYY')
                                  : val
                                : 'N/A';
                              return (
                                <TableCell key={attr}>{display}  </TableCell>
                              );
                            })}
                            <TableCell>
                              <IconButton
                                size="small"
                                onClick={() => {
                                  const deletedRow = {
                                    ...rowData,
                                    actionType: 'delete'
                                  };
                                  setTableListDatas((prev) =>
                                    prev.map((r) =>
                                      r.id === rowData.id ? deletedRow : r
                                    )
                                  );
                                  handleCheckboxChange(deletedRow, true, 'delete');
                                }}
                              >
                                <DeleteIcon fontSize="small" color="error" />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        )
                      ))}


                    <TableRow>
                      <TableCell colSpan={columns.length + 3} align="center">
                        <IconButton onClick={handleAddRow} color="primary">
                          <AddIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell colSpan={columns.length + 3} >
                        <Grid container>
                          <Grid item xs={12}>
                            <TablePagination
                              rowsPerPageOptions={[10, 20, 30, 40]}
                              component="div"
                              count={totalCount}
                              rowsPerPage={rowsPerPage}
                              page={offset}
                              onPageChange={handleChangePage}
                              onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                          </Grid>
                        </Grid>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </div>
          {uploadOpen && <UploadSumInsuredGroupWithAction isGmc={true} closeWindow={closeGroupDataUploadForm}
            sectionId={sectionId} groupId={groupId} rfqId={policyDetails?.rfqId} productId={productId}
            policyId={policyDetails?.id}
            headerList={sumInsuredData?.sumInsuredHeaderSorted}
          />}
          <ExcelSummaryBox endorsementFormData={endorsementFormData} sectionId={sectionId} groupId={groupId} />
        </>
      )}
    </>
  );
}

export default EmployeeListItem;
